import React, { useState } from 'react'
import { useDispatch } from 'react-redux'

import { RouteComponentProps } from 'react-router-dom'

import { Col, Form, Row } from 'react-bootstrap'
import { Button, Select, Title } from 'src/components'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

import { CardProviderEnum, CardProviderOptions } from 'src/enums/CardProviderEnum'
import { CardPagaloForm } from 'src/content/CardProviders/CardProvider/Forms/Pagalo/CardPagaloForm'

import { handlerWarning } from 'src/selectors/error.selector'
import { showAlert } from 'src/actions/alert.actions'

import { onValidate } from 'src/content/CardProviders/CardProvider/Forms/Pagalo/utils/CardPagaloUtils'
import { CardPagaloTermsConditions } from 'src/content/CardProviders/CardProvider/Forms/Pagalo/CardPagaloTermsConditions'

interface IProcessRequest {
  show: boolean
  request: IPagaloRequest
}

export const CardProviderPage = ({ history }: RouteComponentProps) => {
  const dispatch = useDispatch()

  const [data, setData] = useState<ICardProviderDTO>({
    provider: CardProviderOptions[0],
  })
  const [dataPagalo, setDataPagalo] = useState<Partial<IPagaloForm>>({})

  const [process, setProcess] = useState<IProcessRequest>({
    show: false,
    request: undefined,
  })

  const onSave = () => {
    if (!data?.provider?.value) showWarningAlert('Es necesario seleccionar un proveedor')
    else {
      switch (data.provider.value) {
        case CardProviderEnum.PAGALO:
          {
            const response = onValidate(dataPagalo as IPagaloForm)
            if (!response.isOk) showWarningAlert(response.error)
            else {
              setProcess({ show: true, request: response.request })
            }
          }
          break
      }
    }
  }

  const showWarningAlert = (message: string) => {
    dispatch(showAlert(handlerWarning('Información', message)))
  }

  return (
    <div>
      <Title title={'Conectar proveedor'} />
      <Row>
        <Col xl={10} lg={10} md={9} sm={12} xs={12}>
          <Select
            label={'Proveedor'}
            required
            options={CardProviderOptions}
            value={data.provider}
            placeholder={'Selecciona un proveedor'}
            onChange={(provider: ISelectNumber) => setData({ ...data, provider })}
            // disabled={disabled}
          />
        </Col>
        <Col xl={2} lg={2} md={3} sm={12} xs={12}>
          <Row className={'container-buttons mt-5'}>
            <Button icon={faPlus} onClick={onSave} style={{ width: '100%' }}>
              Solicitar
            </Button>
          </Row>
        </Col>
      </Row>

      <Form>
        <Row>
          {data.provider?.value === CardProviderEnum.PAGALO && (
            <Col xl={12}>
              <CardPagaloForm data={dataPagalo} setData={setDataPagalo} />
            </Col>
          )}
        </Row>
      </Form>

      <CardPagaloTermsConditions
        show={process.show}
        request={process.request}
        onHide={success => {
          setProcess({ ...process, show: false })
          if (success) history.goBack()
        }}
      />
    </div>
  )
}
